import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`${t("login.subtitle").replace(".", "")} — ${u.full_name}`);
      nav(u.role === "admin" ? "/admin" : u.role === "seller" ? "/vendeur" : "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("login.error"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative bg-[#1A3322]">
        <img src="https://images.unsplash.com/photo-1514425263458-109317cc1321?w=1200" alt="marché" className="absolute inset-0 w-full h-full object-cover opacity-50"/>
        <div className="relative z-10 flex flex-col justify-end h-full p-12 text-white">
          <span className="label-uppercase text-xs text-[#D98A2C]">SUKANACOOP</span>
          <h2 className="heading font-extrabold text-4xl mt-4 leading-tight">{t("header.products")} & {t("header.services")}</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-5" data-testid="login-form">
          <div>
            <h1 className="heading font-extrabold text-3xl text-[#111812]">{t("login.title")}</h1>
            <p className="text-sm text-[#4B5563] mt-2">{t("login.subtitle")}</p>
          </div>
          <div className="space-y-2">
            <Label>{t("login.email")}</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com" data-testid="login-email"/>
          </div>
          <div className="space-y-2">
            <Label>{t("login.password")}</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" data-testid="login-password"/>
          </div>
          <div className="text-right"><Link to="/mot-de-passe-oublie" className="text-sm text-[#C85A32]" data-testid="forgot-link">{t("login.forgot")}</Link></div>
          <Button type="submit" disabled={loading} className="w-full pill-btn bg-[#1A3322] hover:bg-[#24472F] rounded-full h-11" data-testid="login-submit">
            {loading ? t("login.loading") : t("login.submit")}
          </Button>
          <p className="text-sm text-center text-[#4B5563]">
            {t("login.no_account")} <Link to="/inscription" className="text-[#1A3322] font-semibold" data-testid="to-register">{t("login.register")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
